<template>
  <b-row v-if="alertMessages && alertMessages.length" class="alert-messages pt-3" :class="{'match-verify': isMatchVerifyError}">
    <b-col>
      <b-alert
        show dismissible
        :variant="getVariant"
        v-for="(alertMessage, index) in alertMessages"
        :key="'alert-msg-' + index.toString()"
        class="alert-height"
      ><div v-html="alertMessage"></div></b-alert>
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from 'vuex'
import { getErrorData } from '@/utils'

export default {
  name: 'Alert',
  computed: {
    ...mapState(['status', 'messages', 'error', 'isMatchVerifyError']),
    alertMessages: function() {
      let msgs = []

      if (this.status) {
        if (this.messages && this.messages.length) {
          msgs = this.messages.slice()
        } else if (this.error && this.status === 'error') {
          let error = Object.assign({}, this.error)
          let status = 500

          if (error.status) {
            status = error.status
          } else if (error.response && error.response.status) {
            status = error.response.status
          }

          if (status === 500) {
            msgs = ['An internal server error occurred']
          } else if (status === 400) {
            msgs = ['The data you entered is not valid.  Please check that all fields are correct.']
          } else {
            if (error.error) {
              error = error.error
            }

            const response = error.response || error

            if (response.data) {
              const err = getErrorData(error)

              if (err.message) {
                msgs = [err.message]
              } else {
                msgs = [response.data.detail || response.statusText || response.message || error.message]
              }
            } else {
              msgs = [response.statusText || response.message || error.message]
            }
          }

          console.log(error)
        }
      }

      return msgs
    },
    getVariant: function() {
      if (this.status === 'error') {
        return 'danger'
      }

      return this.status
    }
  }
}
</script>

<style scoped>

</style>
